<template>
  <a-modal
    title="员工列表"
    :visible="visible"
    @cancel="visible = fasle"
    width="50%"
    cancelText="关闭"
    @ok="submitForm">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item label="员工昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>


            <a-col :md="12" :sm="24">
              <a-form-item label="考勤状态" prop="isWork">
                <a-select v-model="queryParam.isWork" placeholder="请选择考勤状态" allow-clear>
                  <a-select-option value="0">下班</a-select-option>
                  <a-select-option value="1">上班</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button type="danger" :disabled="multiple" style="margin-left: 8px" @click="handleDelete">
                  清空
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">

      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="userId"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <img style="width: 48px;height: 48px;" preview="分类图片" v-if="record.avatar" :src="record.avatar" slot="avatar"
             slot-scope="text, record">
        <span slot="userType" slot-scope="text, record">
          <div v-if="record.clientType == 2">
            {{ record.userType == 1 ? '推荐官' : record.userType == 2 ? '推荐官专员' : '推荐官经理人' }}
          </div>
          <div v-if="record.clientType == 1">
            {{ record.userType == 2 ? '招聘专员' : '驻场客服' }}
          </div>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import {queryUserByType} from '@/api/user/rule'
import {tableMixin} from '@/store/table-mixin'

export default {
  name: 'VideoComment',
  components: {
    // CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      visible: false,
      selectedRowKeys: [],
      selectedRows: [],
      userList: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        clientType: null,
        nickname: null,
        isWork: null,
        pageNum: 1,
        pageSize: 100
      },
      columns: [
        // {
        //   title: '用户编号',
        //   dataIndex: 'account',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'avatar'}

        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '考勤状态',
          dataIndex: 'isWork',
          customRender: function (type) {
            if (type == 0) {
              return '下班'
            } else if (type == 1) {
              return '上班'
            }
          },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户角色',
          dataIndex: 'userType',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'userType'}
        }
      ]
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  methods: {
    submitForm() {
      if (this.selectedRows.length) {
        this.$emit('ok', this.selectedRows)
        this.visible = false
      } else {
        this.$message.warning('请选择用户')
      }
    },
    openByTwoClient(rows) {
      this.selectedRows = rows
      this.selectedRowKeys = rows.map(item => item.userId)
      this.queryParam.clientType = 2
      this.getList()
      this.visible = true
    },
    openByThreeClient(rows) {
      this.selectedRows = rows
      this.selectedRowKeys = rows.map(item => item.userId)
      this.queryParam.clientType = 1
      this.getList()
      this.visible = true
    },
    /** 查询短视频评论列表 */
    getList() {
      this.loading = true
      queryUserByType(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.userId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const that = this
      that.onSelectChange([], [])
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('video/video/comment/export', {
            ...that.queryParam
          }, `短视频评论_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
<style scoped>
/deep/ .ant-card-body {
  padding: 0 !important;
}
</style>
